/** @format */

import React, { FunctionComponent } from 'react';
import MvnoBlockRequestState from '../../interfaces/platform/MvnoBlockRequestState';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import { history } from '../../core/history';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { ConfigWrapper } from '../../core/ConfigWrapper';

type GoToCallBlockType = {
    mvnoBlockRequestState: MvnoBlockRequestState;
};

export type CallBlock = {
    blockId: number;
};

export const GoToCallBlock: FunctionComponent<GoToCallBlockType> = ({ mvnoBlockRequestState }) => {
    const config = new ConfigWrapper();

    const callViewBlock = (block: CallBlock): void => {
        history.push(FormGeneralHelper.getRouteUrl('/block-request-detail/' + config.getApiMvnoBlockRequestById(block.blockId)));
    };

    if (mvnoBlockRequestState.calledMvnoBlockRequestId) {
        return (
            <CustomTextButtom
                callback={callViewBlock}
                callbackParam={{ blockId: mvnoBlockRequestState.calledMvnoBlockRequestId }}
                label="prov:vb.view_called_block"
                valueObject={{ blockId: mvnoBlockRequestState.calledMvnoBlockRequestId }}
            />
        );
    }

    if (mvnoBlockRequestState.messageRequest) {
        try {
            const jsonObject = JSON.parse(mvnoBlockRequestState.messageRequest);

            if (jsonObject) {
                return jsonObject.map((blockId: number) => {
                    return (
                        <CustomTextButtom
                            key={'call_block_' + blockId}
                            callback={callViewBlock}
                            callbackParam={{ blockId: blockId }}
                            label="prov:vb.view_called_block"
                            valueObject={{ blockId: blockId }}
                        />
                    );
                });
            }
        } catch (error) {
            console.log(error);
        }
    }
    return null;
};
